import { getProductColorInMaker, getRealFcanvass } from '../../../../Maker/F/getSth.js';
import { BpOptionUploadTypeS } from '../../../../BpOption/UploadType/S/Function/module/BpOptionUploadTypeS.js';
import { NewMakerPropertyBaseProductS } from '../../../Property/BaseProduct/S/Function/module/NewMakerPropertyBaseProductS.js';
import { SVGEditorUtilF } from '../../../../SVGEditor/Util/F/Function/module/SVGEditorUtilF.js';
import { UtilF } from '../../../../Util/F/Function/module/UtilF.js';
import { onbeforeunload_event_off } from '../../../../Maker/F/util.js';
import { ConfigSentryF } from '../../../../Config/Sentry/F/Function/module/ConfigSentryF.js';
import { $qs } from 'fxdom/es';
import { BpOptionS } from '../../../../BpOption/S/Function/module/BpOptionS.js';
import { BpOptionF } from '../../../../BpOption/F/Function/module/BpOptionF.js';
import { NewMakerCompositePreviewF } from '../../../CompositePreview/F/Function/module/NewMakerCompositePreviewF.js';
import { getIsBizProduct } from '../../../../Maker/S/product.js';
import { bizOptionMenus } from '../../../../Maker/F/Marpplizer/biz.js';
import { every, go } from 'fxjs/es';
import { OMPDosuF } from '../../../../OMP/Dosu/F/Function/module/OMPDosuF.js';
import { NewMakerPropertyBaseProductF } from '../../../Property/BaseProduct/F/Function/module/NewMakerPropertyBaseProductF.js';
import { NewMakerLegacyF } from '../../../Legacy/F/Function/module/NewMakerLegacyF.js';
import {
  check_all_in_all_sizes3,
  isMakerDone,
  moveToFcanvasIncludingSwiper,
} from '../../../../Maker/F/overflow.js';
import { removeCvBlueLineInMaker } from '../../../../Maker/F/cv_blue_line.js';
import { OMPMakerEventMakerF } from '../../../../OMP/MakerEvent/Maker/F/Function/module/OMPMakerEventMakerF.js';
import { NewMakerEndServiceF } from '@modules/NewMaker/EndService/F/Function/module/NewMakerEndServiceF.js';

function showAlert({ content, title }) {
  if (G.mp.maker.alert) {
    G.mp.maker.alert({ content, title }).then();
  } else {
    $.alert(content).then();
  }
}

async function prepareCartForAdd() {
  const product = getProductColorInMaker();
  const bp_option_groups_el = $qs('.bp_option_groups');
  const has_bp_option_groups = BpOptionS.getBaseProductsListBpOptionGroups(product._.base_product)?.length;
  if (has_bp_option_groups)
    product._.selected_option_group = BpOptionF.makeSelectedOptionGroup(bp_option_groups_el);

  if (!UtilF.isLegacyMobile()) {
    if (product.product_faces2?.value[0]?.designs?.length) {
      const result = await NewMakerCompositePreviewF.openCompositePreview(product);
      if (result?.frame_done === false) return;
    }
  }

  box.unset('maker->product_color->id');
  box.unset('maker->product_color->product_id');
  box.unset('maker->product_color->thumbnails');

  const { is_pure_biz_product } = getIsBizProduct(product);
  if (is_pure_biz_product) {
    bizOptionMenus.upsert.toBoxAtPf2();
  }

  if (BpOptionF.biz.get.currentBp.hasDosuRelatedOptions()) {
    const is_done_dosu = await go(
      box.sel('maker->product_color->product_faces2->value'),
      every(async (pf) => {
        const dosu_confirm = await OMPDosuF.dosu_confirm.isMoreThanLimitedDosu(pf.bpf_id, pf.designs);
        if (dosu_confirm === undefined) return true;
        if (dosu_confirm === true) {
          await NewMakerPropertyBaseProductF.linkToBpId.goTo(async () => {
            if (UtilF.isLegacyMobile()) {
              await _p.go(G.mp.maker.zoom.canvas_container_display_mode(), NewMakerLegacyF.swiperInit);
            }
          });

          return;
        }
        const fcanvas = getRealFcanvass().find((fcanvas) => {
          return fcanvas.bpf_id === pf.bpf_id;
        });
        await moveToFcanvasIncludingSwiper(fcanvas);
      }),
    );
    if (!is_done_dosu) return;
  }

  removeCvBlueLineInMaker();

  if (NewMakerEndServiceF.makerStatus.isPlainOrderCheckNotPassed()) {
    const title = TT('maker::alert::plain_order_check::title');
    const content = TT('maker::alert::plain_order_check::content');
    showAlert({ content, title });
    return;
  }

  if (NewMakerEndServiceF.makerStatus.isMoqOrderCheckNotPassed()) {
    const content = T(`maker::moq::has_not_design`);
    showAlert({ content });
    return;
  }

  if (!(await isMakerDone())) return;
  if (box.sel('maker->event')) {
    if (
      !(await OMPMakerEventMakerF.shinhanIsGoodCondition(
        box.sel('maker->event'),
        box.sel('maker->product_color'),
      ))
    )
      return;
  }
  box.set('maker->product_color->og_image_url', null);
  check_all_in_all_sizes3();
  return true;
}
// if (NewMakerCallConditionPopupF.is_mapping_confirm_popup()) {
//   const is_disabled = e.target.classList.contains('btn_disabled');
//   if (is_disabled) {
//     G.mp.maker.unselect_all();
//     return;
//   }
// }
export async function isNextStepAllowed() {
  const MAKER_TYPE = box.sel('maker->product_color->_->base_product->maker_type');
  const is_user = box.sel('is_user');
  await G.mp.maker.cleared();
  const product_color = getProductColorInMaker();
  let loaderDone = null;
  if (
    BpOptionUploadTypeS.UPLOAD_TYPE.isEditorType(product_color) &&
    NewMakerPropertyBaseProductS.pdfFilePossible.isIt(product_color._.base_product) &&
    MAKER_TYPE !== 'FLEXI'
  ) {
    loaderDone = SVGEditorUtilF.percentLoader({
      message: T('modules::VectorEditor::AcrylicFigure::message::make_images'),
      time: 8 * 1000,
      clazz: UtilF.isLegacyMobile() ? 'mobile' : 'pc',
    });
  } else {
    $.don_loader_start();
  }
  try {
    if (!(await prepareCartForAdd())) {
      $.don_loader_end();
      if (loaderDone) await loaderDone().catch(() => {});
      return false;
    }
  } catch (e) {
    if (loaderDone) await loaderDone().catch(() => {});
    ConfigSentryF.error(e, { tags: { module: 'mp_maker', detail: 'prepareCartForAdd' } });
    if (
      G.collabo_type === '' &&
      e instanceof TypeError &&
      ['DEFAULT', 'MASKING_TAPE'].includes(MAKER_TYPE) &&
      is_user
    ) {
      $.don_loader_end();
      await $.alert(`${T('maker_error_alert::문제가 발생했습니다. 다시 시도해 주세요.')}[ERROR::02]`);
      onbeforeunload_event_off();
      $.don_loader_start();
      window.location.reload();
      return false;
    } else {
      $.don_loader_end();
      await $.alert(`${T('maker_error_alert::문제가 발생했습니다. 다시 시도해 주세요.')}[ERROR::01]`);
      return false;
    }
  }
  /* 장바구니 동작 시작 */
  $.don_loader_end();
  if (loaderDone) await loaderDone().catch(() => {});
  return true;
}
